import { Box, Paper } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React, { useRef } from "react";
import NoRecord from "../../../Shared/Common/NoRecord";
import { ArrowDown, ArrowUp } from "../../../Shared/Icons";
import { useDataContext } from "./DataContext";
import Row from "./Row";
import useLang from "Shared/hooks/useLanguage";
import useIsMobile from "Shared/hooks/useIsMobile";
import { Loader } from "Shared/Common/Loader";
import PatientSearchInput from "Pages/Patient/PatientDemographic/PatientSearchInput";

const GridData = (props: any) => {
  const { data, loading, filterData, loadGridData, setFilterData } =
    useDataContext();

  const { t } = useLang();
  const isMobile = useIsMobile();
  const searchRef = useRef<any>(null);

  const sortData = async (tabsDetail: any) => {
    searchRef.current.id = searchRef.current.id
      ? searchRef.current.id === "asc"
        ? (searchRef.current.id = "desc")
        : (searchRef.current.id = "asc")
      : (searchRef.current.id = "asc");
    filterData.sortColumn = tabsDetail?.columnKey;
    filterData.sortDirection = searchRef.current.id;
    await loadGridData(false);
  };

  return (
    <div>
      <Box sx={{ height: "auto", width: "100%" }}>
        <div className="table_bordered overflow-hidden">
          <TableContainer
            component={Paper}
            className="shadow-none"
            sx={
              isMobile
                ? {}
                : {
                    maxHeight: "calc(100vh - 100px)",
                    "&::-webkit-scrollbar": {
                      width: 7,
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "#fff",
                    },
                    "&:hover": {
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "var(--kt-gray-400)",
                        borderRadius: 2,
                      },
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "var(--kt-gray-400)",
                      borderRadius: 2,
                    },
                  }
            }
          >
            <Table
              aria-label="table with sticky header"
              stickyHeader
              // stickyFooter
              className="table table-cutome-expend table-bordered table-sticky-header table-head-2-bg table-bg table-head-custom table-vertical-center border-0 mb-0"
            >
              {!props.tabsInfo ? null : (
                <TableHead>
                  <TableRow className="h-40px">
                    <TableCell></TableCell>
                    {props?.tabsInfo &&
                      props?.tabsInfo?.map((tabsDetail: any) => (
                        <>
                          {tabsDetail?.isShowOnUi &&
                            !tabsDetail?.isExpandData &&
                            tabsDetail?.isShow && (
                              <>
                                <TableCell sx={{ width: "max-content" }}>
                                  <div className="d-flex justify-content-center align-items-center">
                                    <div style={{ width: "max-content" }}>
                                      {tabsDetail?.filterColumnsType && (
                                        <PatientSearchInput
                                          column={tabsDetail}
                                          loadData={loadGridData}
                                          searchValue={filterData}
                                          setSearchValue={setFilterData}
                                          setFilters={props.setFilters}
                                          filters={props.filters}
                                          setCurPage={props.setCurPage}
                                        />
                                      )}
                                    </div>
                                  </div>
                                </TableCell>
                              </>
                            )}
                        </>
                      ))}
                  </TableRow>
                  <TableRow>
                    <TableCell></TableCell>
                    {props?.tabsInfo &&
                      props?.tabsInfo?.map((tabsDetail: any) => (
                        <>
                          {tabsDetail.isShowOnUi &&
                            !tabsDetail.isExpandData &&
                            tabsDetail.isShow && (
                              <>
                                <TableCell sx={{ width: "max-content" }}>
                                  <div
                                    onClick={() => {
                                      if (
                                        tabsDetail.columnKey !== "ResultFile" &&
                                        tabsDetail.columnKey !== "View" &&
                                        tabsDetail.columnKey !== "Report" &&
                                        tabsDetail.columnKey !== "PrintLabel"
                                      ) {
                                        sortData(tabsDetail);
                                      }
                                    }}
                                    className="d-flex justify-content-between cursor-pointer"
                                    id=""
                                    ref={searchRef}
                                  >
                                    <div style={{ width: "max-content" }}>
                                      {t(tabsDetail?.columnLabel)}
                                    </div>
                                    {tabsDetail.columnKey !== "ResultFile" &&
                                      tabsDetail.columnKey !== "View" &&
                                      tabsDetail.columnKey !== "Report" &&
                                      tabsDetail.columnKey !== "PrintLabel" && (
                                        <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                                          <ArrowUp
                                            CustomeClass={`${
                                              filterData.sortDirection ===
                                                "asc" &&
                                              filterData.sortColumn ===
                                                tabsDetail.columnKey
                                                ? "text-danger fs-6"
                                                : "text-gray-700 fs-7"
                                            }  p-0 m-0 "`}
                                          />
                                          <ArrowDown
                                            CustomeClass={`${
                                              filterData.sortDirection ===
                                                "desc" &&
                                              filterData.sortColumn ===
                                                tabsDetail.columnKey
                                                ? "text-danger fs-6"
                                                : "text-gray-700 fs-7"
                                            }  p-0 m-0`}
                                          />
                                        </div>
                                      )}
                                  </div>
                                </TableCell>
                              </>
                            )}
                        </>
                      ))}
                  </TableRow>
                </TableHead>
              )}
              <TableBody>
                {loading ? (
                  <TableCell colSpan={10}>
                    <Loader />
                  </TableCell>
                ) : data?.gridData?.length ? (
                  data?.gridData?.map((RowData: any) => (
                    <>
                      <Row
                        RowData={RowData}
                        tabsInfo={props?.tabsInfo}
                        key={RowData?.RequisitionOrderId}
                      />
                    </>
                  ))
                ) : (
                  <NoRecord />
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </Box>
    </div>
  );
};

export default React.memo(GridData);
